newsDirective = angular.module('news.setting', [])

newsDirective.directive "newsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "$rootScope", "$state", ($window, $timeout, $compile, $templateCache, ns, $rootScope, $state) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  link: (scope, element, attrs, ngModel) ->
    widgetEl = angular.element("[data-block-id='#{attrs.widgetId}']")


    render = (newsPage, widget) ->
      allHtml = ""
      if newsPage.length is 0
        allHtml = "<div style='text-align:center;'>
          <svg width='58' viewBox='0 0 58 58' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'>
            <defs>
              <g id='icon'>
                <circle cx='4.002' cy='28' r='4.001'/>
                <path d='M6.023 20.004c3.309 0 6 2.691 6 6.004h4.002c0-5.516-4.488-10.008-10.002-10.008v4.004zm-.027-8.004c7.719 0 14.002 6.285 14.002 14.008h4.002c0-9.93-8.076-18.008-18.004-18.008v4zm0-8c12.133 0 22.004 9.871 22.004 22.008h4c0-14.344-11.663-26.008-26.004-26.008v4z' />
              </g>
            </defs>
            <use x='10' y='10' style='fill: #e6e9ef; color: #e6e9ef' xlink:href='#icon' />
          </svg>
        </div>"
      else
        newsPage = angular.copy newsPage[0]
        newsPage.pages = newsPage.pages.slice 0, widget.max_news
        title = newsPage.name
        titleHtml = "<h2 class='strw-news__title'>#{title}</h2>"
        allHtml += titleHtml if widget.show_title
        _.each newsPage.pages, (post) ->
          dividerHtml = "&nbsp; &nbsp;|&nbsp;&nbsp;&nbsp; "
          if widget.show_author and widget.show_published_at
            innerHtml = "Автор: #{post.author} #{dividerHtml}Дата: #{post.published_at}"
          else if widget.show_author
            innerHtml = "Автор: #{post.author}"
          else if widget.show_published_at
            innerHtml = "Дата: #{post.published_at}"
          else
            innerHtml = ""
          dateAndAuthorHtml = "<h6 class='small' style='padding: 10px 20px 10px 0px;'>
              <span style='font-weight:regular;'>
                <span style='font-family:open sans;'>
                  <span style='color:rgba(114, 114, 114, 1);'>
                    #{innerHtml}
                  </span>
                </span>
              </span>
            </h6>"
          postHtml = "<article class='strw-news__post'>
            <h5>
              <span style='font-weight:600;'>
                <span style='font-family:open sans;'>
                  <a class='strw-news__post-link' href='/#{$state.params.siteId}/#{post.path}/editor'>
                    #{post.name}
                  </a>
                </span>
              </span>
            </h5>
            #{dateAndAuthorHtml}
            <span style='font-weight:regular;display:block;'>
              <span style='font-family:open sans;'>
                <span style='line-height:2;'>
                  #{post.short_text}
                </span>
              </span>
            </span>
            <a href='/#{$state.params.siteId}/#{post.path}/editor' class='strw-news__read-button'>ЧИТАТЬ ДАЛЬШЕ</a>
          </article>"
          allHtml += postHtml

      widgetEl.find(ns.widgetWrapperClass).html allHtml


    listener = scope.$watch "data", (newVal) ->
      newsPage = _.filter $rootScope.site.pages, {id: newVal.news_id}
      render newsPage, newVal
    , true


    scope.$on "$destroy", ->
      listener()

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/news/news.directive.coffee